import RigSupervisorsManagement from './form'

const rigSupervisorsManagement = {
    name: 'Rig Supervisors Management',
    url: '#/rigSupervisorsManagement',
    alias: 'rigSupervisorsManagement',
    ico: 'liveico-supervisor',
    position: 'first-block',
    addRoute: true,
    routeUrl: 'rigSupervisorsManagement',
    component: RigSupervisorsManagement
}

try {
    require('./init')
    var ExtensionService = require('live/services/extension')

    ExtensionService.addAdminMenu(rigSupervisorsManagement)
} catch (e) {
    console.error(e)
}
